import WordSearch from "../../../../Components/Games/WordSearch";
import Crossword from "../../../../Components/Games/Crossword";
import Quiz from "../../../../Components/Games/Quiz";
import Newsie from "../../../../Components/Games/Newsie";

import "./CreateGames.css";
import CreateGameOptionButton from "./CreateGameOptionButton";
import { GAMES } from "Util/constants";
import CollectContentForm from "./CollectContentForm";

const CREATE_GAMES_SCREENS = {
  ...GAMES,
  SELECT_GAME: "select_game",
};

const CreateGamesContainer = (props) => {
  const {
    puzzleType,
    onClickExitCreateGames,
    handleWordsearchContent,
    handleCrosswordContent,
    handleNewsieContent,
    handleQuizContent,
    handleSelectGameType,
    handleClickBack,
    draftPuzzle,
    crosswordWordsInput,
    contentRecieved,
    wordsearchWordsInput,
    puzzleTitle,
    edit,
  } = props;

  console.log({ puzzleType, contentRecieved });

  if (!puzzleType)
    return (
      <div>
        <div className="choose-your-puzzle-directive-container">
          Choose a puzzle
        </div>
        <div className="create-games-row-selector-container">
          <CreateGameOptionButton
            game={GAMES.NEWSIE}
            onSelectGameType={handleSelectGameType}
          />
          <CreateGameOptionButton
            game={GAMES.WORDSEARCH}
            onSelectGameType={handleSelectGameType}
          />
          <CreateGameOptionButton
            game={GAMES.CROSSWORD}
            onSelectGameType={handleSelectGameType}
          />
          <CreateGameOptionButton
            game={GAMES.QUIZ}
            onSelectGameType={handleSelectGameType}
            justIcon={false}
          />
        </div>
      </div>
    );

  if (puzzleType && !contentRecieved)
    return (
      <CollectContentForm
        puzzleType={puzzleType}
        onClickExitCreateGames={onClickExitCreateGames}
        onWordsearchContent={handleWordsearchContent}
        onCrosswordContent={handleCrosswordContent}
        onNewsieContent={handleNewsieContent}
        onQuizContent={handleQuizContent}
      />
    );
  if (puzzleType === CREATE_GAMES_SCREENS.NEWSIE)
    return (
      <Newsie
        puzzleTitle={puzzleTitle}
        onClickBack={handleClickBack}
        draftNewsie={draftPuzzle}
      />
    );
  if (puzzleType === CREATE_GAMES_SCREENS.WORDSEARCH)
    return (
      <WordSearch
        puzzleTitle={puzzleTitle}
        wordsInput={wordsearchWordsInput}
        size={10}
        onClickBack={handleClickBack}
      />
    );
  if (puzzleType === CREATE_GAMES_SCREENS.QUIZ) {
    return (
      <Quiz
        onClickBack={handleClickBack}
        draftPuzzle={draftPuzzle}
        puzzleTitle={puzzleTitle}
      />
    );
  }

  if (puzzleType === CREATE_GAMES_SCREENS.CROSSWORD)
    return (
      <Crossword
        puzzleTitle={puzzleTitle}
        onClickBack={handleClickBack}
        draftWordsAndClues={crosswordWordsInput}
        edit={edit}
      />
    );
  // Should This be here
  return <></>;
};

export default CreateGamesContainer;
